const queryKeys = {
  homeUpcoming: ['home', 'upcoming'],
  homeBookAgain: ['home', 'book-again'],
  homeTopLocations: ['home', 'top-locations'],
  picksForYou: ['home', 'picks-for-you'],
  homeFavorites: ['home', 'favorites'],
  homeComingSoon: ['home', 'coming-soon'],
} as const;

export default queryKeys;
